export default __webpack_public_path__ + "static/media/401-9ZUI-WEB.4d913d67.svg";